import React, { Component } from 'react';
import ImportData from '../../components/Import/ImportData.js';
import ImportCompanies from '../../components/Import/ImportCompanies.js';
import ImportContacts from '../../components/Import/ImportContacts.js';
import ImportSalesOpportunities from '../../components/Import/ImportSalesOpportunities.js';
import Mail from '../../components/Mail/Mail.js';
import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import PermissionWrapper from '../../auth/PermissionWrapper.js';
import {
  Container, Row, Col
} from 'reactstrap';

class Utilities extends Component {

  render() {
    return (<Container fluid className='p-0'>
      <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
        <Row>
          <Col md={12} className='text-center'>
            <h1>Utilities</h1>
          </Col>
        </Row>
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Mail Test" hidden={true}>
        <Mail {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Import SEC Data" hidden={true}>
        <ImportData {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Import Companies" hidden={true}>
        <ImportCompanies {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Import Contacts" hidden={true}>
        <ImportContacts {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Import Sales Opportunities" hidden={true}>
        <ImportSalesOpportunities {...this.props} />
      </PermissionWrapper>
    </Container>)
  }
}

export default Utilities;
